import { createFileRoute } from '@tanstack/react-router';
import AvailabilityCreate from '~/containers/AvailabilityCreate';

export const Route = createFileRoute('/availability/create')({
  component: AvailabilityCreate,
  validateSearch(search) {
    return {
      from: (search.from as string) || undefined,
      publisherId: (search.publisherId as string) || undefined,
    };
  },
});
